import { ModuleNames } from '../../src/constants/componentNames.constants'

const ModuleMapping: { [key: string]: string } = {
  //* pages
  pageResource: ModuleNames.PAGE_CUSTOMER_STORY,
  pageWhitePaper: ModuleNames.PAGE_WHITE_PAPER,
  pageAnalystReport: ModuleNames.PAGE_ANALYST_REPORT,
  pagePlaceholder: ModuleNames.PAGE_PLACEHOLDER,
  pageResourceDemo: ModuleNames.PAGE_RESOURCE_DEMO,
  pageAboutRpa: ModuleNames.PAGE_ABOUT_RPA,
  pageBlogPost: ModuleNames.PAGE_BLOG_POST,
  pageMainBlog: ModuleNames.PAGE_MAIN_BLOG,
  pageFlex: ModuleNames.PAGE_FLEX,
  pageSolutions: ModuleNames.PAGE_SOLUTIONS,
  pageRawHtml: ModuleNames.PAGE_RAW_HTML,
  pageAgencyTest: ModuleNames.PAGE_AGENCY_TEST,
  pageProduct: ModuleNames.PAGE_PRODUCT,
  pageProductDownload: ModuleNames.PAGE_PRODUCT_DOWNLOAD,
  pageThankYou: ModuleNames.PAGE_THANK_YOU,
  pageWebinarRecording: ModuleNames.PAGE_WEBINAR_RECORDING,

  //* components
  componentAnnouncement: ModuleNames.ANNOUNCEMENT,
  componentBio: ModuleNames.BIO,
  componentHero: ModuleNames.HERO,
  componentFlexibleHero: ModuleNames.FLEXIBLE_HERO,
  componentTiles: ModuleNames.TILES,
  componentThreeTiles: ModuleNames.THREETILES,
  componentCardSlider: ModuleNames.CARD_SLIDER,
  componentFeaturedResource: ModuleNames.FEATURED_RESOURCE,
  componentFeaturedTiles: ModuleNames.FEATURED_TILES,
  componentHeroTabs: ModuleNames.HERO_TABS,
  componentOverview: ModuleNames.OVERVIEW,
  componentAssetText: ModuleNames.MEDIA_TEXT,
  componentIcons: ModuleNames.ICONS,
  componentSpotlight: ModuleNames.VIDEO_SPOTLIGHT,
  componentDivider: ModuleNames.DIVIDER,
  componentContentBlock: ModuleNames.GLOBAL_CONTENT_BLOCK,
  componentContentRows: ModuleNames.CONTENT_ROWS,
  componentCollapsibleQuadrant: ModuleNames.COLLAPSIBLE_QUADRANT,
  componentGrid: ModuleNames.GRID,
  componentMainCta: ModuleNames.GLOBAL_MAIN_CTA,
  componentKeyStats: ModuleNames.GLOBAL_KEY_STATS,
  componentBenefits: ModuleNames.BENEFITS,
  componentPlatformDiagram: ModuleNames.PLATFORM_DIAGRAM,
  componentQuote: ModuleNames.QUOTE,
  componentColumns: ModuleNames.GLOBAL_CONTENT_COLUMNS,
  componentResourceTabs: ModuleNames.RESOURCE_TABS,
  componentMediaAsset: ModuleNames.MEDIA_ASSET,
  componentMediaTextVariants: ModuleNames.MEDIA_TEXT_VARIANTS,
  componentResourceRow: ModuleNames.RESOURCE_ROW,
  componentResourceLists: ModuleNames.RESOURCE_LISTS,
  componentParagraphBlock: ModuleNames.PARAGRAPH_BLOCK,
  componentTable: ModuleNames.TABLE,
  componentSlider: ModuleNames.SLIDER,
  componentMarketoForm: ModuleNames.MARKETO_FORM,
  componentProductDownload: ModuleNames.PRODUCT_DOWNLOAD_COMPONENT,
  componentSpeakerText: ModuleNames.SPEAKER_TEXT,
  componentRawHtml: ModuleNames.RAW_HTML,
  teaser: ModuleNames.TEASER,
  featuredSlider: ModuleNames.FEATURED_SLIDER,
  componentCustomNav: ModuleNames.CUSTOM_NAV,
  componentMainNavBanner: ModuleNames.MAIN_NAV_BANNER,
  componentThankYouFeaturedResource: ModuleNames.THANK_YOU_FEATURED_RESOURCE,
  seoPageData: ModuleNames.SEO,
  componentLoadingContainer: ModuleNames.LOADING_CONTAINER,
  componentVideoRecording: ModuleNames.VIDEO_RECORDING,

  //* topics
  topicAutomationUseCase: ModuleNames.AUTOMATION_USE_CASE,
  topicAnchorLink: ModuleNames.ANCHOR_LINK,
  topicCustomerDetails: ModuleNames.TOPIC_CUSTOMER_DETAILS,
  topicCta: ModuleNames.TOPIC_CTA,
  topicInternalLink: ModuleNames.TOPIC_INTERNAL_LINK,
  topicMediaTile: ModuleNames.TOPIC_MEDIA_TILE,
  topicFaq: ModuleNames.TOPIC_FAQ,
  topicAgenda: ModuleNames.TOPIC_AGENDA,
  topicResourceIndustry: ModuleNames.TOPIC_INDUSTRY,
  topicResourceDepartment: ModuleNames.TOPIC_DEPARTMENT,
  topicResourceTopic: ModuleNames.TOPIC_RESOURCE_TOPIC,
  topicResourceProduct: ModuleNames.TOPIC_RESOURCE_PRODUCT,
  topicWebinarType: ModuleNames.TOPIC_WEBINAR_TYPE,
  topicResourceRegion: ModuleNames.TOPIC_REGION,
  topicOfficeRegion: ModuleNames.TOPIC_OFFICE_REGION,
  topicIconLink: ModuleNames.TOPIC_ICON_LINK,
  topicCompanyBio: ModuleNames.TOPIC_COMPANY_BIO,
  topicPartnerDetails: ModuleNames.TOPIC_PARTNER_DETAILS,
  topicEventType: ModuleNames.TOPIC_EVENT_TYPE,
  topicResourceList: ModuleNames.RESOURCE_LINK_CATEGORY,
  topicCity: ModuleNames.TOPIC_CITY,
  topicCountry: ModuleNames.TOPIC_COUNTRY,
  topicOfficeLocation: ModuleNames.TOPIC_OFFICE_LOCATION,
  topicTextTile: ModuleNames.TOPIC_TEXT_TILE,
  topicBreadcrumbs: ModuleNames.TOPIC_BREADCRUMB,
  topicItemList: ModuleNames.TOPIC_ITEM_LIST,

  //* wrappers/menu/microcopy
  menuGroup: ModuleNames.MENU_GROUP,
  navMenu: ModuleNames.MENU_NAV,
  wrapperPdf: ModuleNames.WRAPPER_PDF,
  WrapperAsset: ModuleNames.WRAPPER_ASSET,
  wrapperVideo: ModuleNames.WRAPPER_VIDEO,
  microcopySet: ModuleNames.MICROCOPY_SET,
}

export default ModuleMapping
